module.exports = __webpack_public_path__ + "static/Mortgage-89a597d0851ea91d5fe657daa208bef3.gif";